import 'core-js';
import Core from './components/Core';
import Boot from './components/Boot';

new Boot().then(() => {
  new Core();
});